import * as React from "react";
import {
  List, Datagrid, TextField, FunctionField,
  Show, SimpleShowLayout,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { TechInfo } from "../../components/ui";

// Codes d'affiliation. AffiliationCode entity : id, code, owner (User),
// createdAt. Source : GET /admin/affiliation-codes (paginé, Content-Range).
export default {
  list: () => (
    <List sort={{ field: "createdAt", order: "DESC" }} perPage={50}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="code" label="Code" />
        <FunctionField label="Propriétaire" render={(r) => r?.ownerId ? (
          <a href={`#/users/${r.ownerId}/show`} style={{ color: "#0d7377", fontWeight: 600 }}>
            {r.owner || r.ownerId}
          </a>
        ) : "—"} />
        <FunctionField label="Créé le" render={(r) => r?.createdAt
          ? new Date(Number(r.createdAt)).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })
          : "—"} />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="code" />
        <FunctionField label="Propriétaire" render={(r) => r?.ownerId ? (
          <a href={`#/users/${r.ownerId}/show`} style={{ color: "#0d7377", fontWeight: 600 }}>
            {r.owner || r.ownerId}
          </a>
        ) : "—"} />
        <FunctionField label="Créé le" render={(r) => r?.createdAt
          ? new Date(Number(r.createdAt)).toLocaleString("fr-FR") : "—"} />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
